// Billing analytics API surface. M7c / P5.
//
// 🔴 Every figure is PER CURRENCY. We sell in seven and hold no FX table, so
// there is deliberately no blended total anywhere in these types — a single
// "revenue" number would be fiction that looks authoritative.

import { api } from './api';

export interface RevenueTotal {
  currency: string;
  collectedMinor: number;
  refundedMinor: number;
  discountMinor: number;
  netMinor: number;
  invoiceCount: number;
}

export interface RevenuePoint {
  day: string;
  collectedMinor: number;
  refundedMinor: number;
}

export interface RevenueSeries {
  currency: string;
  /** Dense: one point per day in the window, zero-filled. */
  points: RevenuePoint[];
}

export interface RevenueReport {
  from: string;
  to: string;
  totals: RevenueTotal[];
  series: RevenueSeries[];
}

export interface SubscriptionReport {
  from: string;
  to: string;
  /** Monthly-normalised; yearly plans contribute 1/12. Excludes the free tier. */
  mrrByCurrency: Record<string, number>;
  arrByCurrency: Record<string, number>;
  activePaidSubscriptions: number;
  newInWindow: number;
  churnedInWindow: number;
  /** churned ÷ the base that existed at the window start. Null if no base. */
  churnRate: number | null;
  byStatus: Record<string, number>;
  byPlan: Record<string, number>;
  byInterval: Record<string, number>;
}

export async function getRevenueReport(
  range: { from: string | null; to: string | null },
  signal?: AbortSignal,
): Promise<RevenueReport> {
  return api(`/admin/reports/billing/revenue${rangeQuery(range)}`, { signal });
}

export async function getSubscriptionReport(
  range: { from: string | null; to: string | null },
  signal?: AbortSignal,
): Promise<SubscriptionReport> {
  return api(`/admin/reports/billing/subscriptions${rangeQuery(range)}`, { signal });
}

function rangeQuery(range: { from: string | null; to: string | null }): string {
  const params = new URLSearchParams();
  if (range.from) params.set('from', range.from);
  if (range.to) params.set('to', range.to);
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}
